import { useGetCategoryQuery } from "../store/api/directory/categoryApi"


export const balanceColumn = [
    {
        attr: "guid",
        label: "guid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        label: "codeid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country",
        label: "country",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "fullname",
        label: "fullname",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "personal_account",
        label: "personal_account",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "balance",
        label: "balance",
        type: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "date_create",
        label: "date_create",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "desc",
        label: "desc",
        type: 1,
        hidden: false,
        editor: true
    }

]